export type TimestampsModel<
  U extends boolean = true,
  C extends boolean = false,
> = (U extends true ? {updatedAt: string | null} : object) &
  (C extends true ? {createdAt: string | null} : object);

export type PaginationModel = {
  // INFO: how many recods per page.
  size: number;
  // INFO: which is the current page.
  current: number;
  // INFO: how many pages.
  pagesCount: number;
  // INFO: how many records in total.
  totalCount: number;
};

export type PaginationQueryModel = {
  current: number;
  size: number;
};

export type ListModel<T, P extends boolean = true> = {
  records: T[];
} & (P extends true ? {pagination: PaginationModel} : object);

// TODO: make keep date-fs object instead.
export type DateModel = string;

export type ImageModel = {
  url: string | null;
};

export enum APIMethodEnum {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}
